import React, { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../components/ui/dropdown-menu';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { MoreHorizontal, ArrowRight, XCircle } from 'lucide-react';
import { dealsAPI } from '../../services/api';
import { toast } from '../../hooks/use-toast';


const DealStageDropdown = ({ currentStage, dealId, onUpdate }) => {
  const [loading, setLoading] = useState(false);

  const stages = [
    { value: 'POST_DEMO_FOLLOW_UP', label: 'Post Demo' },
    { value: 'PROPOSAL_SHARED', label: 'Proposal Shared' },
    { value: 'NEGOTIATION_IN_PROGRESS', label: 'Negotiation' },
    { value: 'PROCUREMENT_APPROVAL_PENDING', label: 'Procurement' },
    { value: 'ON_HOLD_BAD_TIMING', label: 'On Hold' },
    { value: 'PENDING_ADMIN_APPROVAL', label: 'Done (Request Approval)' },
    // Won stages are usually restricted, but user asked for "Jump to any"
    { value: 'WON_PAYMENT_PENDING', label: 'Won (Payment Pending)' },
    { value: 'WON_PAYMENT_RECEIVED', label: 'Won (Paid)' },
    { value: 'LOST_PRICE', label: 'Lost - Price' },
    { value: 'LOST_TO_COMPETITOR', label: 'Lost - Competitor' },
    { value: 'LOST_NO_DECISION', label: 'Lost - No Decision' },
  ];

  const handleStageChange = async (newStage) => {
    try {
      setLoading(true);
      if (newStage.startsWith('WON')) {
          // If moving to WON, use approve endpoint if it was pending, or standard update?
          // Standard update handles it but might have logic checks.
          // Let's use standard update for flexibility as requested.
          await dealsAPI.update(dealId, { deal_stage: newStage });
      } else {
          await dealsAPI.update(dealId, { deal_stage: newStage });
      }
      onUpdate();
    } catch (error) {
      console.error("Failed to update stage", error);
      toast({
        variant: 'destructive',
        title: 'Failed to update stage',
        description: error.response?.data?.detail || error.message
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-6 w-6 p-0" disabled={loading}>
          <MoreHorizontal className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 max-h-[300px] overflow-y-auto">
        <DropdownMenuLabel>Move to Stage</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {stages.map((stage) => (
          <DropdownMenuItem 
            key={stage.value}
            onClick={(e) => { e.stopPropagation(); handleStageChange(stage.value); }}
            className={currentStage === stage.value ? 'bg-slate-100 font-medium' : ''}
          >
            {stage.value === currentStage && <span className="mr-2 text-blue-500">•</span>}
            {stage.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DealStageDropdown;
